import { render, staticRenderFns } from "./Webcastle.vue?vue&type=template&id=3630bd67&"
import script from "./Webcastle.vue?vue&type=script&lang=js&"
export * from "./Webcastle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports